"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var video_sources_1 = require("@wix/wix-vod-constants/dist/common/video-sources");
var vimeo_1 = tslib_1.__importDefault(require("./external/vimeo"));
var youtube_1 = tslib_1.__importDefault(require("./external/youtube"));
var facebook_1 = tslib_1.__importDefault(require("./external/facebook"));
var fullScreenChangeEventsList = [
    'fullscreenchange',
    'mozfullscreenchange',
    'webkitfullscreenchange',
    'msfullscreenchange',
];
var playersMap = (_a = {},
    _a[video_sources_1.VIDEO_SOURCES.YOUTUBE] = youtube_1.default,
    _a[video_sources_1.VIDEO_SOURCES.VIMEO] = vimeo_1.default,
    _a[video_sources_1.VIDEO_SOURCES.FACEBOOK] = facebook_1.default,
    _a);
var ExternalPlayer = /** @class */ (function (_super) {
    tslib_1.__extends(ExternalPlayer, _super);
    function ExternalPlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleFullscreenChange = function () {
            _this.props.onFullScreenChanged(_this.isInFullScreen);
        };
        return _this;
    }
    ExternalPlayer.prototype.UNSAFE_componentWillMount = function () {
        if (typeof document !== 'undefined') {
            this.addFullscreenEventHandler();
        }
    };
    ExternalPlayer.prototype.componentWillUnmount = function () {
        this.removeFullscreenEventHandler();
    };
    Object.defineProperty(ExternalPlayer.prototype, "isInFullScreen", {
        get: function () {
            return Boolean(document.fullscreenElement ||
                document.mozFullScreenElement ||
                document.webkitFullscreenElement ||
                document.msFullscreenElement);
        },
        enumerable: true,
        configurable: true
    });
    ExternalPlayer.prototype.addFullscreenEventHandler = function () {
        var _this = this;
        lodash_1.default.forEach(fullScreenChangeEventsList, function (eventName) {
            return document.addEventListener(eventName, _this.handleFullscreenChange);
        });
    };
    ExternalPlayer.prototype.removeFullscreenEventHandler = function () {
        var _this = this;
        lodash_1.default.forEach(fullScreenChangeEventsList, function (eventName) {
            return document.removeEventListener(eventName, _this.handleFullscreenChange);
        });
    };
    ExternalPlayer.prototype.render = function () {
        var _a = this.props, locale = _a.locale, videoItem = _a.videoItem, isVideoPlayRequested = _a.isVideoPlayRequested, isVideoPauseRequested = _a.isVideoPauseRequested, isVideoPlaying = _a.isVideoPlaying, isVideoPaused = _a.isVideoPaused, onPlay = _a.onPlay, onPause = _a.onPause, onEnded = _a.onEnded, onIframeRef = _a.onIframeRef, onVolumeChange = _a.onVolumeChange;
        if (!videoItem) {
            return null;
        }
        var id = videoItem.id, externalId = videoItem.externalId, mediaExternUrl = videoItem.mediaExternUrl, videoSource = videoItem.videoSource;
        var ExternalPlayer = playersMap[videoSource];
        if (!ExternalPlayer) {
            return null;
        }
        return (react_1.default.createElement(ExternalPlayer, tslib_1.__assign({}, this.props, { locale: locale, key: id || externalId, showControls: true, isVideoPlayRequested: isVideoPlayRequested, isVideoPauseRequested: isVideoPauseRequested, isVideoPlaying: isVideoPlaying, isVideoPaused: isVideoPaused, src: mediaExternUrl, onPlay: onPlay, onPause: onPause, onEnd: onEnded, onVolumeChange: onVolumeChange, onIframeRef: onIframeRef })));
    };
    ExternalPlayer.propTypes = {
        compId: prop_types_1.default.string,
        isVideoPlayRequested: prop_types_1.default.bool,
        isVideoPauseRequested: prop_types_1.default.bool,
        isVideoPlaying: prop_types_1.default.bool,
        isVideoPaused: prop_types_1.default.bool,
        muted: prop_types_1.default.bool,
        onPlay: prop_types_1.default.func,
        onPause: prop_types_1.default.func,
        onEnded: prop_types_1.default.func,
        onVolumeChange: prop_types_1.default.func,
        onIframeRef: prop_types_1.default.func,
        onFullScreenChanged: prop_types_1.default.func,
        videoItem: prop_types_1.default.object.isRequired,
        width: prop_types_1.default.number,
        height: prop_types_1.default.number,
        className: prop_types_1.default.string,
        locale: prop_types_1.default.string,
    };
    ExternalPlayer.defaultProps = {
        onPlay: lodash_1.default.noop,
        onPause: lodash_1.default.noop,
        onEnded: lodash_1.default.noop,
        onError: lodash_1.default.noop,
        onFullScreenChanged: lodash_1.default.noop,
        onIframeRef: lodash_1.default.noop,
        onVolumeChange: lodash_1.default.noop,
    };
    return ExternalPlayer;
}(react_1.default.Component));
exports.default = ExternalPlayer;
//# sourceMappingURL=player-external.js.map